import React from 'react'

import ApplySkeleton from '@core/components/ApplyDialogV2/ApplySkeleton'
import decodeHtmlEntitiesRecursive from '@core/utils/helpers/decodeHtmlEntitiesRecursive'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'

import type { PostInfoV2 } from '@page/post-v2/types'

import './PostPageV2Industries.scss'

const baseClass = 'PostPageV2Industries'

interface PostPageV2IndustriesProps {
    postInfo?: PostInfoV2 | undefined | null
    isLoading?: boolean
}

function PostPageV2Industries({ postInfo, isLoading }: PostPageV2IndustriesProps) {
    const { getTitle } = useApplyV2NavTranslations()

    if (isLoading) {
        return (
            <div className={baseClass}>
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'40%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
            </div>
        )
    }
    if (
        !postInfo?.data?.industry?.firstCategory &&
        !postInfo?.data?.industry?.firstSubCategory &&
        !postInfo?.data?.industry?.secondCategory &&
        !postInfo?.data?.industry?.secondSubCategory
    ) {
        return null
    }

    return (
        <div className={baseClass}>
            {(postInfo?.data?.industry?.firstCategory ||
                postInfo?.data?.industry?.firstSubCategory ||
                postInfo?.data?.industry?.secondCategory ||
                postInfo?.data?.industry?.secondSubCategory) && (
                <div className={`${baseClass}__row ${baseClass}__industry`}>
                    <div className={`${baseClass}__title ${baseClass}__industry__title`}>
                        {getTitle('256', 'Industry')}
                    </div>
                    <div className={`${baseClass}__categories ${baseClass}__industry__categories`}>
                        {(postInfo?.data?.industry?.firstCategory || postInfo?.data?.industry?.firstSubCategory) && (
                            <div className={`${baseClass}__categories--item`}>
                                <div className={`${baseClass}__categories--item-main`}>
                                    {decodeHtmlEntitiesRecursive(postInfo?.data?.industry?.firstCategory)}
                                </div>
                                <div className={`${baseClass}__categories--item-sub`}>
                                    {decodeHtmlEntitiesRecursive(postInfo?.data?.industry?.firstSubCategory)}
                                </div>
                            </div>
                        )}
                        {(postInfo?.data?.industry?.secondCategory || postInfo?.data?.industry?.secondSubCategory) && (
                            <div className={`${baseClass}__categories--item`}>
                                <div className={`${baseClass}__categories--item-main`}>
                                    {decodeHtmlEntitiesRecursive(postInfo?.data?.industry?.secondCategory)}
                                </div>
                                <div className={`${baseClass}__categories--item-sub`}>
                                    {decodeHtmlEntitiesRecursive(postInfo?.data?.industry?.secondSubCategory)}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {(postInfo?.data?.keywords ?? []).length > 0 && (
                <div className={`${baseClass}__row ${baseClass}__keywords`}>
                    <div className={`${baseClass}__title ${baseClass}__keywords__title`}>
                        {getTitle('343', 'Keywords')}
                    </div>
                    <div className={`${baseClass}__keywords--list`}>
                        {(postInfo?.data?.keywords ?? []).map((word) => (
                            <div key={word.id} className={`${baseClass}__keywords--list--item`}>
                                {word.keyword}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default PostPageV2Industries
